import { Box, Button, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useLocation, useNavigate } from 'react-router-dom';
import { bodyWidth } from '../../utils/Style';
import { useThemeColor } from '../../hooks/useThemeColor';
import { GenericHelmet } from '../../components/Helmet/GenericHelmet';

export const OrderErrorPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(location.search);
  const message = queryParams.get('message');

  const { primary, secondary } = useThemeColor();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'center',
      }}
    >
      <GenericHelmet title='Bir Hata Oluştu' />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: bodyWidth,
          alignItems: 'center',
          py: 3,
          px: 1.5,
          boxSizing: 'border-box',
        }}
      >
        <ErrorOutlineIcon sx={{ fontSize: 120, color: primary }} />

        <Typography sx={{ fontSize: '40px', fontWeight: 600 }}>
          Ödeme başarısız oldu
        </Typography>

        <Typography sx={{ fontSize: '24px' }}>
          {message ||
            'Lütfen bilgilerinizin doğruluğunu kontrol edip tekrar deneyiniz'}
        </Typography>

        <Button
          onClick={() => navigate('/sepet')}
          variant='contained'
          sx={{
            textTransform: 'none',
            backgroundColor: primary,
            color: secondary,
            mt: 1.5,
          }}
        >
          Sepete Git
        </Button>
      </Box>
    </Box>
  );
};
